
import { Component, Prop, Vue, Provide } from 'vue-property-decorator';
import moment from 'moment';
moment.locale('zh-cn');
import changeAirport from '../assets/js/airport/changeAirport';

@Component({
    filters: {
        Date(data: any) {
            return moment(data).format('MM月DD日 dddd');
        },
        OnTimeRate(data: any) {
            if (data) {
            return (data * 100).toFixed(2) + '%';
            }
            return '未知';
        },
        City(data: any) {
            return changeAirport.changeAirportCode(data).cityCName || '无';
        },
        AirPort(data: string) {
            return changeAirport.changeAirportCode(data).airportCName || '无';
        },
        AirLine(data: string) {
            return changeAirport.changeAirCompany(data) || '无';
        },
    },
})
export default class AirPortTicketInfo extends Vue {
  @Prop() private airport: any;
  @Prop() private color: any;
  @Prop({default: false}) private margin: any;

  // +1 日期格式
  private filterTime(time: string) {
    return time ? (time.indexOf('+1') !== -1 ? time.replace(/\+1/g, '<span class="nextday">+1天</span>') : time) : '';
  }
}
